import { render, staticRenderFns } from "./incidentReportYears.vue?vue&type=template&id=6e96f4d4"
import script from "./incidentReportYears.vue?vue&type=script&lang=js"
export * from "./incidentReportYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports